import type { PointerEvent } from 'react';
import React from 'react';
import { styled } from 'baseui';
import { CSS_VARIABLE_STAGE_SCALE, CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../../../constants/stage-css-variables';
import { VERTEX_RADIUS, VERTEX_RESIZE_CURSOR } from './constants';
import { type VertexT } from './types';
const Circle = styled<'circle', {
  $isGhost: boolean;
  $isRelationshipView: boolean;
}>('circle', ({
  $isGhost,
  $isRelationshipView
}) => ({
  transformOrigin: '50% 50%',
  transformBox: 'fill-box',
  transform: `scale(var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`,
  ':hover': !$isRelationshipView ? {
    transform: `scale(calc(1.5 / var(${CSS_VARIABLE_STAGE_SCALE})))`,
    transition: '0.4s transform'
  } : {},
  ':focus': {
    strokeWidth: '2px'
  },
  ':active': {
    strokeWidth: '2px'
  },
  pointerEvents: $isGhost ? 'none' : 'auto'
}));
type Props = {
  onSelect?: (e: PointerEvent) => void;
  onDeselect?: (e: PointerEvent | null) => void;
  onMouseEnter?: (e: PointerEvent | null) => void;
  onMouseLeave?: (e: PointerEvent | null) => void;
  vertex: VertexT;
  disableDrag?: boolean;
  isGhostVertex?: boolean;
  isRelationshipView?: boolean;
  strokeColor?: string;
  borderColor?: string;
};
const Vertex = ({
  vertex,
  onSelect,
  onDeselect,
  onMouseEnter,
  onMouseLeave,
  disableDrag,
  isGhostVertex,
  isRelationshipView,
  strokeColor,
  borderColor
}: Props) => {
  return <Circle style={{
    cursor: disableDrag || isRelationshipView ? 'initial' : VERTEX_RESIZE_CURSOR[vertex.type]
  }} onPointerDown={(e: PointerEvent<SVGCircleElement>) => {
    onSelect?.(e);
  }} onPointerUp={() => {
    onDeselect?.(null);
  }} onPointerEnter={(e: PointerEvent<SVGCircleElement>) => {
    onMouseEnter?.(e);
  }} onPointerLeave={(e: PointerEvent<SVGCircleElement>) => {
    onMouseLeave?.(e);
  }} cx={vertex.point[0]} cy={vertex.point[1]} fill={vertex.color ?? strokeColor ?? 'white'} strokeWidth="1" stroke={borderColor ?? strokeColor ?? 'black'} r={VERTEX_RADIUS} opacity={isGhostVertex ? 0.5 : 1} {...disableDrag ? {} : {
    'data-stage-draggable': true
  }} data-testid={vertex.type} $isGhost={isGhostVertex ?? false} $isRelationshipView={isRelationshipView ?? false} />;
};
export default Vertex;